import MultiPolygon from './MultiPolygon';

export default MultiPolygon;
